import React from 'react';

export const GridPatternTopLeft: React.FC = () => (
  <svg
    className='absolute top-0 left-0 pointer-events-none rotate-180'
    xmlns='http://www.w3.org/2000/svg'
    width='148'
    height='135'
    viewBox='0 0 148 135'
    fill='none'
  >
    <rect width='43.2857' height='43.2857' transform='matrix(1 0 0 -1 0.154541 173.297)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(1 0 0 -1 43.4403 130.012)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(1 0 0 -1 43.4403 173.297)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(1 0 0 -1 86.726 86.7261)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(1 0 0 -1 86.726 130.012)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(1 0 0 -1 86.726 173.297)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(1 0 0 -1 130.012 43.4403)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(1 0 0 -1 130.012 86.7261)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(1 0 0 -1 130.012 130.012)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(1 0 0 -1 130.012 173.297)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
  </svg>
);
